import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, mergeProps as _mergeProps, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_typography = _resolveComponent("base-typography")!
  const _component_base_label = _resolveComponent("base-label")!
  const _component_base_form_inline_entry_description = _resolveComponent("base-form-inline-entry-description")!

  return (_openBlock(), _createElementBlock("div", _mergeProps({ class: _ctx.$attrs.class }, { style: _ctx.baseStyle }), [
    _createElementVNode("div", {
      class: _normalizeClass(["base-form-input-container", _ctx.noLabelClass])
    }, [
      (!_ctx.noLabel)
        ? (_openBlock(), _createBlock(_component_base_label, {
            key: 0,
            class: _normalizeClass(["base-label-custom", _ctx.labelClasses])
          }, {
            default: _withCtx(() => [
              _createVNode(_component_base_typography, { subtitle3: "" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.staticLabel || _ctx.label), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["class"]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ], 2),
    _createVNode(_component_base_form_inline_entry_description, {
      errorMessage: _ctx.errorMessage,
      description: _ctx.description
    }, null, 8, ["errorMessage", "description"])
  ], 16))
}